import { TaxFormType } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";
import { useFocusedFeatures } from "../../../FocusedFeatures";
import { useUserId } from "../../../query/hooks/helpers";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { useQueryPayeeTaxForms } from "../../../query/taxForm/queries/useQueryPayeeTaxForms";
import { useAccountAccess } from "../../../v3/hooks/useAccountAccess";
import { useCurrentTaxDocumentsYear } from "./useCurrentTaxDocumentsYear";

export const useIsTaxDocumentsExist = (year: number) => {
  const userId = useUserId();
  const featureFlagsQuery = useFeatureFlags();
  const focusedFeatures = useFocusedFeatures();
  const { hasFullAccess } = useAccountAccess();
  const currentTaxDocumentsYear = useCurrentTaxDocumentsYear();

  const queryPayerTaxForms = useQueryPayeeTaxForms(
    { year: year || currentTaxDocumentsYear, type: TaxFormType.Form1099Nec },
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false
    }
  );

  const isPayeeOnTaxForms = useMemo(() => {
    if (year === 2023) {
      return (
        hasFullAccess &&
        queryPayerTaxForms.data &&
        queryPayerTaxForms.data.length > 0 &&
        queryPayerTaxForms.data.some(taxForm => taxForm.memberId === userId)
      );
    } else {
      return (
        focusedFeatures.showSideNavTaxDocumentsSettings &&
        hasFullAccess &&
        featureFlagsQuery.data?.taxDocumentsSeason2024List &&
        queryPayerTaxForms.data?.length
      );
    }
  }, [
    year,
    hasFullAccess,
    queryPayerTaxForms.data,
    userId,
    focusedFeatures.showSideNavTaxDocumentsSettings,
    featureFlagsQuery.data?.taxDocumentsSeason2024List
  ]);

  return !!isPayeeOnTaxForms;
};
